import { Link } from "react-router-dom";
import {
  depthOf,
  resolveTrail,
  rewindHref,
  rootHref,
  type NavState,
} from "@/navigation/trail";
import { getAsset } from "@/data/catalogue";

export function PinnedBar({ state }: { state: NavState }) {
  if (!state.trail.length) return null;

  const steps = resolveTrail(state.trail);
  const last = steps.at(-1)!;
  const origin = getAsset(last.ref);
  const depth = depthOf(state.trail);
  const MAX_SEGMENTS = 6;

  return (
    <div className="pinbar">
      <span className="m-label">Punto di partenza</span>

      {origin && (
        <span className="pinref" title={origin.label}>
          <span className="glyph" aria-hidden="true">
            ◈
          </span>
          <span>
            <span className="nm">{origin.label}</span>{" "}
            <span className="rf">
              {origin.ref}
              {last.detail ? ` · ${last.detail}` : ""}
            </span>
          </span>
        </span>
      )}

      <nav className="crumbs" aria-label="Percorso di ricerca">
        <Link to={rootHref(state)}>
          {state.query ? `“${state.query}”` : "ricerca"}
        </Link>
        {steps.map((s, i) => (
          <span key={`${s.ref}-${i}`}>
            <span className="sep"> &#x203a; </span>
            {i === steps.length - 1 ? (
              <span className="now">{s.origin}</span>
            ) : (
              <Link to={rewindHref(state, i)}>{s.origin}</Link>
            )}
          </span>
        ))}
      </nav>

      <div className="depth" title={`Profondità drill-down: livello ${depth}`}>
        <span className="m-label">Profondità</span>
        <span className="seg" aria-hidden="true">
          {Array.from({ length: MAX_SEGMENTS }, (_, i) => (
            <i key={i} className={i < depth ? "on" : ""} />
          ))}
        </span>
        <span className="n">
          {depth}
          {depth > MAX_SEGMENTS ? "" : ` / ${MAX_SEGMENTS}`}
        </span>
      </div>
    </div>
  );
}
